export function onClose() {
  this.setState({isModalOpen: false, editService: undefined});
}
